
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {updateObject} from 'utils/reducerUtils';
import AudioPlayer from 'components/AudioPlayer';
import Countdown from 'components/Countdown';
import strings from 'utils/strings';
import wordsNo from './data/no.json';
import wordsNn from './data/nn.json';
import wordsNoUpper from './data/noUpperGrade.json';
import wordsNnUpper from './data/nnUpperGrade.json';

import wordsAudioNo from './data/noAudio';
import wordsAudioNn from './data/nnAudio';
import wordsAudioNoUpper from './data/noAudioUpper';
import wordsAudioNnUpper from './data/nnAudioUpper';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faVolumeHigh} from '@fortawesome/free-solid-svg-icons';

const wordsObj = {
    no: wordsNo,
    nn: wordsNn,
};

const wordsUpperGradeObj = {
    no: wordsNoUpper,
    nn: wordsNnUpper,
};

const audioObj = {
    no: wordsAudioNo,
    nn: wordsAudioNn,
};

const audioObjUpper = {
    no: wordsAudioNoUpper,
    nn: wordsAudioNnUpper,
};

const normingExcludedItemIds = {
    lower: [7, 14],
    upper: [4],
};

let initialAudioIndex = 0;

class Test extends React.Component {
    constructor(props) {
        super(props);

        const selectedLanguage = strings.getLanguage() || 'no';

        const words =
            this.props.candidateGrade < 5
                ? wordsObj[selectedLanguage]
                : wordsUpperGradeObj[selectedLanguage];

        const audio =
            this.props.candidateGrade < 5
                ? audioObj[selectedLanguage]
                : audioObjUpper[selectedLanguage];

        const excludedItemIds =
            this.props.candidateGrade < 5
                ? normingExcludedItemIds.lower
                : normingExcludedItemIds.upper;

        this.words = this.props.isDldTest
            ? words.filter(
                  (question) => !excludedItemIds.includes(question.id)
              )
            : words;

        this.audio = this.props.isDldTest
            ? audio.filter(
                  (_, index) =>
                      !excludedItemIds.includes(words[index].id)
              )
            : audio;

        const results = {};

        this.chooseSynonym = this.props.isDldTest
            ? strings.chooseSynonymNorming
            : strings.chooseSynonym;

        for (const question of this.words) {
            results[question.id] = '';
        }

        this.state = {
            results,
            timeRanOut: false,
            showWordAudio: false,
            currentClickedIndex: null,
            showChoiceAudio: false,
            currentChoiceIndex: null,
            showQuestionPlayButton: true,
            showChoicePlayButton: true,
            showMissing: false,
        };

        this.questionRefs = {};
        this.handleNextStep = this.handleNextStep.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.timeRanOut !== this.state.timeRanOut &&
            this.state.timeRanOut
        ) {
            if (this.submitButton) {
                this.submitButton.focus();
            }
        }
    }

    setResults(id, value) {
        this.setState((prevState) => ({
            results: updateObject(prevState.results, {
                [id]: value,
            }),
        }));
    }

    handleNextStep() {
        const {results, timeRanOut} = this.state;
        const {onNextStep, isSendingTestResults} = this.props;

        if (isSendingTestResults) {
            return;
        }

        const firstUnanswered = this.words.find(
            (question) => !results[question.id]
        );

        // Prevent submission if questions remain unanswered
        // and the countdown has not expired.
        if (!timeRanOut && firstUnanswered) {
            this.setState({showMissing: true}, () => {
                const element =
                    this.questionRefs[firstUnanswered.id];

                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            });

            return;
        }


        onNextStep(results);
    }

    render() {
        const {refs, isSendingTestResults} = this.props;

        const {timeRanOut, results, showMissing} = this.state;

        const hasUnanswered = this.words.some(
            (question) => !results[question.id]
        );

        const showValidation =
            showMissing && hasUnanswered && !timeRanOut;

        const validationMessage =
            strings.getLanguage() === 'nn'
                ? 'Svar på alle dei markerte oppgåvene før du går vidare.'
                : 'Svar på alle de markerte oppgavene før du går videre.';

        const minutes = 10;
        const minutesInHour = 60;

        return (
            <div className="lit-test lit-ordforstaelse">
                <div className="lit-infobar">
                    <Countdown
                        duration={minutes * minutesInHour}
                        onComplete={() => {
                            this.setState({
                                timeRanOut: true,
                            });
                        }}
                    />
                </div>

                <p>{this.chooseSynonym}</p>

                {showValidation && (
                    <p
                        className="lit-validation-message"
                        role="alert"
                    >
                        {validationMessage}
                    </p>
                )}

                <div
                    className={classNames({
                        'lit-questions': true,
                        'time-ran-out': timeRanOut,
                    })}
                >
                    {this.words.map((question, mainIndex) => {
                        const {id, choices} = question;

                        const questionNumber = this.props.isDldTest
                            ? mainIndex + 1
                            : id;

                        const currentQuestionValue = results[id];

                        if (timeRanOut && !currentQuestionValue) {
                            return null;
                        }

                        const isUnanswered =
                            showValidation && !currentQuestionValue;

                        initialAudioIndex = initialAudioIndex + 1;

                        const audioSource =
                            this.audio[mainIndex].mainWord;

                        return (
                            <div
                                className={classNames('lit-question', {
                                    'lit-question--unanswered':
                                        isUnanswered,
                                })}
                                key={id}
                                ref={(element) => {
                                    this.questionRefs[id] = element;
                                }}
                            >
                                <div className="question">
                                    <span className="lit-input__label lit-input__label--count">
                                        {questionNumber}
                                    </span>

                                    <span
                                        style={{
                                            display: 'flex',
                                        }}
                                    >
                                        <p
                                            className="question__text"
                                            id={`ordforstaelse-question-${id}`}
                                        >
                                            {this.state.showWordAudio &&
                                                this.state
                                                    .currentClickedIndex ===
                                                    mainIndex && (
                                                    <span
                                                        style={{
                                                            marginLeft: '-16px',
                                                        }}
                                                    >
                                                        <AudioPlayer
                                                            noBorder
                                                            autoplay
                                                            id={initialAudioIndex}
                                                            refs={refs}
                                                            src={audioSource}
                                                            onErrorPlay={() => {
                                                                this.setState({
                                                                    showQuestionPlayButton:
                                                                        true,
                                                                    currentChoiceIndex:
                                                                        null,
                                                                    showChoicePlayButton:
                                                                        true,
                                                                });
                                                            }}
                                                            onComplete={() => {
                                                                this.setState({
                                                                    showQuestionPlayButton:
                                                                        true,
                                                                    currentClickedIndex:
                                                                        null,
                                                                    showChoicePlayButton:
                                                                        true,
                                                                });
                                                            }}
                                                        />
                                                    </span>
                                                )}

                                            <span>
                                                {this.state
                                                    .showQuestionPlayButton && (
                                                    <FontAwesomeIcon
                                                        size="lg"
                                                        className="lit-play-button"
                                                        icon={faVolumeHigh}
                                                        onClick={() => {
                                                            this.setState({
                                                                showWordAudio:
                                                                    true,
                                                                showQuestionPlayButton:
                                                                    false,
                                                                currentClickedIndex:
                                                                    mainIndex,
                                                                showChoicePlayButton:
                                                                    false,
                                                            });
                                                        }}
                                                    />
                                                )}

                                                {!this.state
                                                    .showQuestionPlayButton &&
                                                    this.state
                                                        .currentClickedIndex !==
                                                        mainIndex && (
                                                        <FontAwesomeIcon
                                                            size="lg"
                                                            className="lit-play-button-disabled"
                                                            icon={faVolumeHigh}
                                                        />
                                                    )}
                                            </span>

                                            <span>{question.word}</span>
                                        </p>
                                    </span>
                                </div>

                                <div
                                    className="choices"
                                    role="radiogroup"
                                    aria-labelledby={`ordforstaelse-question-${id}`}
                                    aria-invalid={isUnanswered}
                                >
                                    {choices.map(
                                        (choice, choiceIndex) => {
                                            const choiceLetter =
                                                choice.letter;

                                            const idChoice =
                                                id + choiceLetter;

                                            initialAudioIndex =
                                                initialAudioIndex + 1;

                                            return (
                                                <span
                                                    className="lit-choice"
                                                    key={idChoice}
                                                >
                                                    <input
                                                        checked={
                                                            currentQuestionValue ===
                                                            choiceLetter
                                                        }
                                                        className="lit-choice__field"
                                                        id={idChoice}
                                                        disabled={timeRanOut}
                                                        onChange={() => {
                                                            if (timeRanOut) {
                                                                return;
                                                            }

                                                            this.setResults(
                                                                id,
                                                                choiceLetter
                                                            );
                                                        }}
                                                        type="radio"
                                                    />

                                                    <label
                                                        className="lit-choice__label"
                                                        htmlFor={idChoice}
                                                    >
                                                        <div className="checkbox" />

                                                        <span
                                                            className={
                                                                this.state
                                                                    .showChoiceAudio
                                                                    ? 'lit-play-wrapper-wrapper'
                                                                    : 'lit-play-wrapper'
                                                            }
                                                        >
                                                            {this.state
                                                                .showChoiceAudio &&
                                                                this.state
                                                                    .currentChoiceIndex ===
                                                                    `${mainIndex}${choiceIndex}` && (
                                                                    <span
                                                                        style={{
                                                                            marginLeft:
                                                                                '-16px',
                                                                        }}
                                                                    >
                                                                        <AudioPlayer
                                                                            noBorder
                                                                            autoplay
                                                                            refs={
                                                                                refs
                                                                            }
                                                                            onErrorPlay={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        showQuestionPlayButton:
                                                                                            true,
                                                                                        currentChoiceIndex:
                                                                                            null,
                                                                                        showChoicePlayButton:
                                                                                            true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            onComplete={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        showQuestionPlayButton:
                                                                                            true,
                                                                                        currentChoiceIndex:
                                                                                            null,
                                                                                        showChoicePlayButton:
                                                                                            true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                            src={
                                                                                this
                                                                                    .audio[
                                                                                    mainIndex
                                                                                ][
                                                                                    'potentialSynonyms'
                                                                                ][
                                                                                    choiceIndex
                                                                                ]
                                                                                    .synonym
                                                                            }
                                                                        />
                                                                    </span>
                                                                )}

                                                            {''}
                                                        </span>

                                                        {this.state
                                                            .showChoicePlayButton && (
                                                            <FontAwesomeIcon
                                                                size="lg"
                                                                className="lit-play-button"
                                                                icon={
                                                                    faVolumeHigh
                                                                }
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.preventDefault();

                                                                    this.setState(
                                                                        {
                                                                            showChoiceAudio:
                                                                                true,
                                                                            currentChoiceIndex: `${mainIndex}${choiceIndex}`,
                                                                            showQuestionPlayButton:
                                                                                false,
                                                                            showChoicePlayButton:
                                                                                false,
                                                                        }
                                                                    );
                                                                }}
                                                            />
                                                        )}

                                                        {!this.state
                                                            .showChoicePlayButton &&
                                                            this.state
                                                                .currentChoiceIndex !==
                                                                `${mainIndex}${choiceIndex}` && (
                                                                <FontAwesomeIcon
                                                                    size="lg"
                                                                    className="lit-play-button-disabled"
                                                                    icon={
                                                                        faVolumeHigh
                                                                    }
                                                                />
                                                            )}

                                                        {choice.choice}
                                                    </label>
                                                </span>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <button
                    type="button"
                    className="lit-btn bg-primary"
                    onClick={this.handleNextStep}
                    ref={(ref) => {
                        this.submitButton = ref;
                    }}
                    disabled={isSendingTestResults}
                >
                    {strings.done}
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        testStepAnswers: {isSendingTestResults},
    } = state;

    return {
        isSendingTestResults,
    };
};

export default connect(mapStateToProps)(Test);
